module.exports = __webpack_public_path__ + "img/04n@2x.5aae8f83.svg";